import { render, staticRenderFns } from "./LinkFoldUnfold.vue?vue&type=template&id=34610586"
import script from "./LinkFoldUnfold.vue?vue&type=script&lang=ts"
export * from "./LinkFoldUnfold.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports